import { ChevronRight, Megaphone } from 'lucide-react'
import { useEffect } from 'react'

import { conditionallyLocalizeDate } from 'utils'

function MemberRenewalsBanner ({
  enrollmentWindowEndDate,
}: {
  enrollmentWindowEndDate?: string | null;
}) {
  const currentYear = new Date().getFullYear()
  // Fallback date is Nov 30th, in Javascript 10 = November
  const enrollmentWindowEndDateLocalized = conditionallyLocalizeDate(
    enrollmentWindowEndDate ? new Date(enrollmentWindowEndDate) : new Date(currentYear, 10, 30)
  )

  useEffect(() => {
    window.segment?.page('[EE] Renewals banner viewed', {
      enrollment_window_end_date: enrollmentWindowEndDate,
      coverage_year: currentYear + 1,
    })
  }, [])

  return (
    <div
      className='border rounded-md w-full p-4 mb-4'
      style={{
        background: 'linear-gradient(286.66deg, #904DD4 0%, #4B1377 100%)',
      }}
    >
      <div className='flex flex-col xs:flex-row xs:items-center gap-4 justify-between'>
        <Megaphone size={26} stroke='#FFF' className='shrink-0' />
        <div className='text-white flex-grow'>
          Open enrollment is here! You have until{' '}
          {enrollmentWindowEndDateLocalized} to make any changes for{' '}
          {currentYear + 1} coverage.
        </div>
        <div>
          <button
            className='btn-secondary w-auto mb-0'
            onClick={() => {
              window.segment?.track('[EE] Renewals banner clicked', {
                enrollment_window_end_date: enrollmentWindowEndDate,
                coverage_year: currentYear + 1,
              })
              window.open('/member_onboarding/progress?source=renewals_banner', '_blank')
            }}
          >
            Details
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default MemberRenewalsBanner
